// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-fwwgl-bdlc-index-main_right_content-1C9_S","table":"components-fwwgl-bdlc-index-table-2VkxP"};


//////////////////
// WEBPACK FOOTER
// ./components/fwwgl/bdlc/index.css
// module id = 564
// module chunks = 0